import { Root } from "@radix-ui/react-visually-hidden"
export const VisuallyHidden = Root
